import Cookies from 'js-cookie';
import { callApi } from '../../utils';
import {
  REQUEST_CREATE_SESSION,
  RECEIVE_CREATE_SESSION,
  SET_CREATE_SESSION_FAILURE,
  CLEAR_CREATE_SESSION_ERROR_MESSAGE,
} from '../constants/createSession';

const requestCreateSession = () => ({
  type: REQUEST_CREATE_SESSION,
});

const receiveCreateSession = () => ({
  type: RECEIVE_CREATE_SESSION,
});

const setCreateSessionFailure = error => ({
  type: SET_CREATE_SESSION_FAILURE,
  error,
});

export const clearCreateSessionErrorMessage = () => ({
  type: CLEAR_CREATE_SESSION_ERROR_MESSAGE,
});


export const createSession = () => async (dispatch, getState) => {
  const sessionIdFromCookies = Cookies.get('_bmeSessionId');
  if (sessionIdFromCookies) return;
  dispatch(requestCreateSession());
  const { config } = getState();
  const {
    REACT_APP_BOOKING_PREFIX: bookingPrefix,
    REACT_APP_BOOKING_SUBSCRIPTION_KEY: bookingSubscriptionKey,
    REACT_APP_API_TIMEOUT_MS: timeout,
  } = config;
  try {
    const { data = {} } = await callApi({ method: 'get', url: '/common/session' }, bookingPrefix, bookingSubscriptionKey, timeout);
    const { SessionId } = data.Data || {};
    Cookies.set('_bmeSessionId', SessionId, { expires: 7 });
    dispatch(receiveCreateSession());
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error(error); // eslint-disable-line
    dispatch(setCreateSessionFailure(error));
  }
};
